export const kk = {
    LEFT: 'Солға қарай: алдыңғы күні.',
    RIGHT: 'Оңға: келесі жұмыс күні.',
    DOWN: 'Down: келесі жолы.',
    UP: 'Жоғары: көшу алдыңғы жолында.',
    PGUP: 'Жоғары жылжу: жылжу пайызбен.',
    PGDOWN: 'PgDown: келесі ай.',
    HOME: 'Үйде: алдыңғы жылы.',
    END: 'Соңы: көшіру келесі жылға.',
    ESC: 'Эку/бүгін/жабу: жабу күнтізбе. Нұсқаулықтар',
    TITLE: 'Пернетақта '
};
